import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslate } from "hooks/useTranslate";
import { useNodeActions } from "hooks/projectHooks/useNodeActions/useNodeActions";

const ConfiguratorPopUpContext = createContext({});

export const ConfiguratorPopupProvider = ({ children }) => {
  const translate = useTranslate();
  const nodeActions = useNodeActions();
  const [params, setParams] = useState(null);

  const [navFuncState, setNavFunc] = useState(null);
  const [disableExit, setDisableExit] = useState(false);
  const [isUpdateButtonActive, setIsUpdateButtonActive] = useState(false);

  const handleUpdate = useCallback(() => {
    if (params.kind === "PRODUCT") {
      nodeActions.updateProductNodeConfiguration(
        params.id,
        params.productRequestData,
        (_data) => navFuncState?.(),
      );
    } else {
      nodeActions.updateNode({ id: params.id, data: params }, params);
      navFuncState?.();
    }
  }, [nodeActions, params, navFuncState]);

  const showConfiguratorPopup = useCallback(
    (navFunc) => {
      setNavFunc(() => navFunc); // save function argument reference
      NiceModal.show("confirmation", {
        iconName: "save-regular",
        title: translate("TEXT_SAVE_CHANGES"),
        alertText: translate("SAVE_PRODUCT_DATA_CONFIRMATION_ALERT"),
        submitBtnText: translate("SAVE"),
        onCancel: () => {
          setIsUpdateButtonActive(false);
          navFunc();
        },
      }).finally(() => {
        setParams(null);
        setNavFunc(null);
        setDisableExit(false);
        setIsUpdateButtonActive(false);
      });
    },
    [translate],
  );

  const context = useMemo(
    () => ({
      setParams,
      showConfiguratorPopup,
      disableExit,
      setDisableExit,
      navFuncState,
      handleUpdate,
      isUpdateButtonActive,
      setIsUpdateButtonActive,
    }),
    [
      disableExit,
      handleUpdate,
      navFuncState,
      showConfiguratorPopup,
      isUpdateButtonActive,
    ],
  );

  return (
    <ConfiguratorPopUpContext.Provider value={context}>
      {children}
    </ConfiguratorPopUpContext.Provider>
  );
};
export const useConfiguratorPopupContext = () =>
  useContext(ConfiguratorPopUpContext);
